import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { provide, ref, watch, computed } from 'vue';
import { isSearchOpenKey } from '@/keys';

import useContext from '@/composables/useContext';

import QuickCart from '../components/QuickCart.vue';
import MyPages from '../components/MyPages/MyPages.vue';
import SearchView from '../components/SearchView/SearchView.vue';
import ReviewModal from '@/components/Reviews/ReviewModal.vue';

import useSearch from '@/composables/useSearch';

export default /*#__PURE__*/_defineComponent({
  __name: 'StandardLayout',
  setup(__props) {

useSearch();

const { route, settings } = useContext();
const isSearchOpen = ref(false);
provide(isSearchOpenKey, isSearchOpen);

const isCheckout = computed(() => {
  return route.component == 'page-checkout';
});

const blocks = computed(() => {
  return settings.value?.sitewideBlocks || [];
});

watch(
  () => route.pathname,
  () => {
    isSearchOpen.value = false;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!
  const _component_router_page = _resolveComponent("router-page")!
  const _component_SiteFooter = _resolveComponent("SiteFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isCheckout))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_SiteHeader),
          _createVNode(QuickCart),
          _createVNode(MyPages),
          _createVNode(SearchView)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_blocks_repeater, { blocks: _unref(blocks) }, null, 8, ["blocks"]),
    _createVNode(_component_router_page),
    (!_unref(isCheckout))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_SiteFooter),
          _createVNode(ReviewModal)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})